import { createAction } from '@reduxjs/toolkit';
import {
    IGetRouteAliasPayload,
    IRouteAlias,
    types,
    IGetAllRouteAliasesPayload,
    ICreateRouteAliasPayload,
    IUpdateRouteAliasPayload,
    IDeleteRouteAliasPayload,
    IRouteAliasesResponse,
} from './types';
import { IErrorType } from '../../constants/types';

export const getRouteAlias = createAction<IGetRouteAliasPayload>(types.GET_ROUTE_ALIAS);
export const getRouteAliasSuccess = createAction<IRouteAlias>(types.GET_ROUTE_ALIAS_SUCCESS);
export const getRouteAliasFail = createAction<IErrorType>(types.GET_ROUTE_ALIAS_FAIL);

export const getAllRouteAliases = createAction<IGetAllRouteAliasesPayload>(types.GET_ALL_ROUTE_ALIASES);
export const getAllRouteAliasesSuccess = createAction<IRouteAliasesResponse>(types.GET_ALL_ROUTE_ALIASES_SUCCESS);
export const getAllRouteAliasesFail = createAction<IErrorType>(types.GET_ALL_ROUTE_ALIASES_FAIL);

export const createRouteAlias = createAction<ICreateRouteAliasPayload>(types.CREATE_ROUTE_ALIAS);
export const createRouteAliasSuccess = createAction<IRouteAlias>(types.CREATE_ROUTE_ALIAS_SUCCESS);
export const createRouteAliasFail = createAction<IErrorType>(types.CREATE_ROUTE_ALIAS_FAIL);

export const updateRouteAlias = createAction<IUpdateRouteAliasPayload>(types.UPDATE_ROUTE_ALIAS);
export const updateRouteAliasSuccess = createAction<IRouteAlias>(types.UPDATE_ROUTE_ALIAS_SUCCESS);
export const updateRouteAliasFail = createAction<IErrorType>(types.UPDATE_ROUTE_ALIAS_FAIL);

export const deleteRouteAlias = createAction<IDeleteRouteAliasPayload>(types.DELETE_ROUTE_ALIAS);
export const deleteRouteAliasSuccess = createAction<string>(types.DELETE_ROUTE_ALIAS_SUCCESS);
export const deleteRouteAliasFail = createAction<IErrorType>(types.DELETE_ROUTE_ALIAS_FAIL);
